/*
 * Customer view
 */
function r(t, r) {
  return Math.floor(Math.random() * (r - t + 1) + t);
}
var variation = 800,
    c = r(500, 2000);

$("#counter").text(c);
$("#counter1").text(c);

setInterval(function () {
  var t = r(-variation, variation);
  c += t;
  
  // Ensure #counter1 stays between 250 and 800
  c = Math.max(250, Math.min(c, 800));
  
  $("#counter").text(c);
  $("#counter1").text(c);
}, 3000);

/*
 * Product page sticky add to cart
 
$(function () {
  if ($(".kit-product-template")[0]) {
    var z = $(".kit-product-template").offset().top + $(".kit-product-template").outerHeight();
    $(document).scroll(function () {
      var y = $(this).scrollTop();
      if (y > z) {
        $(".wrapper-selection.add-to-cart").addClass("wrapper-selection-fixed-ATC");
      } else {
        $(".wrapper-selection.add-to-cart").removeClass("wrapper-selection-fixed-ATC");
      }
    });
  }
});
*/

$(window).scroll(function(){
  if ($(this).scrollTop() > 500) {
     $('.image-wrapper-list.product-image').addClass('change_position');
  } else {
     $('.image-wrapper-list.product-image').removeClass('change_position');
  }
});
/*
 * Product page tap button
 */

function setTapBox() {
  var get_tabbox = localStorage.getItem("TapBox");
  if (get_tabbox == "Clicked") {
    $(".tap-click-view").hide();
    $(".tap-hover-view").show();
    $('.kit-product-annoucement').show();
    $('body').addClass('show-annoucement');
    
  } else {
    $(".tap-click-view").show();
    $(".tap-hover-view").hide();
    $('.kit-product-annoucement').hide();
    $('body').removeClass('show-annoucement');
  }
}

$(document).ready(function () {
  setTapBox();
  //$('.kit-v1 .info-bar').attr('style','display: block !important');
  $(".tap-click-view").click(function () {
    localStorage.setItem("TapBox", "Clicked");
    setTapBox();
  });
});

/* Qty plus/mius */
jQuery(document).ready(function(){
  $('.qtyplus').click(function(e){
    e.preventDefault();
    fieldName = $(this).attr('field');
    var currentVal = parseInt($('input[name='+fieldName+']').val());
    if (!isNaN(currentVal)) {
      $('input[name='+fieldName+']').val(currentVal + 1);
    } else {
      $('input[name='+fieldName+']').val(1);
    }
  });
  // This button will decrement the value till 0
  $(".qtyminus").click(function(e) {
    e.preventDefault();
    fieldName = $(this).attr('field');
    var currentVal = parseInt($('input[name='+fieldName+']').val());
    if (!isNaN(currentVal) && currentVal > 1) {
      $('input[name='+fieldName+']').val(currentVal - 1);
    } else {
      $('input[name='+fieldName+']').val(1);
    }
  });
});

$(document).ready(function(){
 var kit_default_color = $("body.kit-v1 .kit-option-label.selected").find('.cs-kit-col').text().trim().replace(/\)\s*\(/g, ' ');
 $('body.kit-v1 .p-variant-selector .p-colorselector').html(kit_default_color);
  
 $('body.kit-v1 .kit-option-label').click(function(){
   var kit_comp_price = $(this).attr('data-vprice');
   $('body.kit-v1 .cross-price-was .cross-through').html(kit_comp_price);
   var kit_d_price = $(this).attr('data-dprice');
   var kit_d_value = $(this).attr('data-value');
   var kit_d_color = $(this).find('.cs-kit-col').text().trim().replace(/\)\s*\(/g, ' ');
   
   $('body.kit-v1 .kit-disc-price').html(kit_d_price);
   $('body.kit-v1 #product-price-selectorr').html(kit_d_price);
   $('body.kit-v1 .p-variant-selector .p-variant').html(kit_d_value);
   $('body.kit-v1 .p-variant-selector .p-colorselector').html(kit_d_color);
   var kit_a_price = $(this).attr('data-aprice');
   $('body.kit-v1 .cs-price-afterpay').html(kit_a_price);
 }); 

 $('body.colour-v1 .kit-option-label').click(function(){
   var kit_comp_price_c = $(this).attr('data-vprice');
   $('body.colour-v1 .cross-price-was .cross-through').html(kit_comp_price_c);
   var kit_d_price_c = $(this).attr('data-dprice');
   $('body.colour-v1 .kit-disc-price').html(kit_d_price_c);
   $('body.colour-v1 #product-price-selectorr').html(kit_d_price_c);
   var kit_a_price_c = $(this).attr('data-aprice');
   $('body.colour-v1 .cs-price-afterpay').html(kit_a_price_c);
   var kit_c_price_c = $(this).find('#var-save-off').val();
   $('body.colour-v1 .cs-colo-dprice').html(kit_c_price_c);
 });
});

/* Fancybox on product image */
$('[data-fancybox="gallery1"]').fancybox({
  loop: true
});
$('[data-fancybox="gallery2"]').fancybox({
  loop: true
});

/* Preshape modals */
$(document).ready(function(){
  $('.cs-preshape-toggle').on('click', function(e) {
    e.preventDefault();
    $('.cs-preshape-modal').toggleClass('is-visible');
    $('.cs-preshape-toggle .custom-add-check i').css("display", "none");
    $('.cs-preshape-toggle #losnaglar').removeAttr("checked");
  });
});
/* Preshape modals option change */
jQuery(document).ready(function(){
  jQuery('.cs-preshape-content [data-product-option-indexes] input[type=radio]').change(function() {
    var optionIndex = jQuery(this).closest('.cs-preshape-content [data-product-option-indexes]').attr('data-product-option-indexes');
    var optionValue = jQuery(this).val();
    jQuery(this).closest('.cs-preshape-content [data-product-option-indexes]').find('.variation-element').removeClass('selected');
    jQuery(this).closest('label').addClass('selected');
    jQuery(this).closest('.cs-preshape-content').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
    jQuery(this).closest('.cs-preshape-content').find('.w-selects').eq(optionIndex).val(optionValue);
    var sel_dta = jQuery(this).closest('.cs-preshape-content').find('.w-selects option:selected').attr('data-val');
    var sel_dta_img = jQuery(this).closest('.cs-preshape-content').find('.w-selects option:selected').attr('data-image');
    //console.log(sel_dta);
    jQuery('input#losnaglar').attr('data-vid', sel_dta);
    if(sel_dta_img) {
      jQuery(this).closest('.cs-preshape-content').find('.cs-main-image-model').attr('src', sel_dta_img);  
    } else {
      jQuery(this).closest('.cs-preshape-content').find('.cs-main-image-model').attr('src', 'https://cdn.shopify.com/s/files/1/0598/5579/8360/files/Losnaglar_photo_2_1.png?v=1719404482');  
    }
  });
});
/* Preshape modals button click */
 jQuery(document).ready(function(){
   $('.cs-preshape--btn').click(function(){
       $('.cs-preshape-modal').toggleClass('is-visible');
        $('.cs-preshape-toggle .custom-add-check i').css("display", "flex");
      $('.cs-preshape-toggle #losnaglar').attr("checked", "checked");     
   });
 });

/* Update product available url query string varinat id */
function updateQueryString(key, value, url) {
  if (!url) url = window.location.href;
  let updated = ''
  var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
      hash;

  if (re.test(url)) {
    if (typeof value !== 'undefined' && value !== null) {
      updated = url.replace(re, '$1' + key + "=" + value + '$2$3');
    } else {
      hash = url.split('#');
      url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
      if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
        url += '#' + hash[1];
      }
      updated = url;
    }
  } else {
    if (typeof value !== 'undefined' && value !== null) {
      var separator = url.indexOf('?') !== -1 ? '&' : '?';
      hash = url.split('#');
      url = hash[0] + separator + key + '=' + value;
      if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
          url += '#' + hash[1];
      }
      updated = url;
    } else {
      updated = url;
    }
  }
  window.history.replaceState({ path: updated }, '', updated);
}

$(document).ready(function(){
  var get_selected_var = $('.custom-cm-inp').val();
  updateQueryString('variant', get_selected_var);
});

/* include kit modals */
$(document).ready(function(){
  var startkit_totalprice = 1092;
  var complettkit_totalprice = 1569;
  var ultimatkit_totalprice = 1887;
  
  $('.include-kit-toggle').on('click', function(e) {
    e.preventDefault();
    var dataKit = $(this).data('kit');
   $('.include-kit-modal .include-kit-value').css('display', 'none');
    if (dataKit === 'Start KIT') {
      $('.include-kit-modal .include-kit-value[data-kit="Start KIT"] .total-value .value').html(startkit_totalprice + ' kr');
      $('.include-kit-modal .include-kit-value[data-kit="Start KIT"]').css('display', 'block');
    } else if (dataKit === 'Komplett KIT') {
      $('.include-kit-modal .include-kit-value[data-kit="Komplett KIT"] .total-value .value').html(complettkit_totalprice + ' kr');
      $('.include-kit-modal .include-kit-value[data-kit="Komplett KIT"]').css('display', 'block');
    } else if (dataKit === 'Ultimat KIT') {
      $('.include-kit-modal .include-kit-value[data-kit="Ultimat KIT"] .total-value .value').html(ultimatkit_totalprice + ' kr');
       $('.include-kit-modal .include-kit-value[data-kit="Ultimat KIT"]').css('display', 'block');
    }
    $('.include-kit-modal').toggleClass('is-visible');
  });
});
